export { default } from './ImageTextAlternateList';
